import * as React from 'react'
import { memo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../store/rootReducer'

import { Link } from '../../../i18next/helpers'

import { GuestbookMessage } from '../../../store/commonTypes'

import { genders } from '../../../constants'
import paths from '../../../paths'
import moment from 'moment-mini'
import DeleteGuestbookMessage from '../popups/deleteGuestbookMessagePopup'
import { deleteGuestbookMessage } from '../../../api/profile'
import { guestbookMessageDelete } from '../../../store/member/memberSlice'
import { userGuestbookMessageDelete } from '../../../store/profile/profileSlice'
import s from './materialPreview.module.sass'

interface Props {
    guestbookItem: GuestbookMessage
}

const GuestbookItem: React.FunctionComponent<Props> = ({ guestbookItem }: Props) => {
    const [t] = useTranslation()
    const [showPopup, setShowPopup] = useState(false)
    const dispatch = useDispatch()

    const { user } = useSelector((state: RootState) => state.member)

    return (
        <div className={s['guestbookItem']}>
            <div className={s['profile']}>
                <div className={s['avatar']}>
                    <img src={guestbookItem.author.avatar_url} alt="" />
                </div>
                <div className={s['description']}>
                    <Link to={paths.profile.toPath({ nick: guestbookItem.author.nick })} className="nick">
                        {guestbookItem.author.nick}
                    </Link>
                    {guestbookItem.author.gender > 0 && (
                        <div className={s['gender']}>
                            {t(genders.find((x) => x.value === guestbookItem.author.gender).label)}
                            {guestbookItem.author.age && `, ${guestbookItem.author.age} ${t('years')}`}
                        </div>
                    )}
                </div>
            </div>
            <div className={s['text']} dangerouslySetInnerHTML={{ __html: guestbookItem.message }} />
            <div className={s['date']}>{moment(guestbookItem.creation_date * 1000).format(t('time format'))}</div>
            {user && (user.id === guestbookItem.user.id || user.id === guestbookItem.author.id) && (
                <div className={s['delete']} onClick={() => setShowPopup(true)} />
            )}
            {showPopup && (
                <DeleteGuestbookMessage
                    onDelete={() => {
                        if (user.id === guestbookItem.user.id)
                            dispatch(guestbookMessageDelete({ id: guestbookItem.id }))
                        if (user.id === guestbookItem.author.id)
                            dispatch(userGuestbookMessageDelete({ id: guestbookItem.id }))
                        deleteGuestbookMessage({ id: guestbookItem.id })
                        setShowPopup(false)
                    }}
                    onClose={() => setShowPopup(false)}
                />
            )}
        </div>
    )
}

export default memo(GuestbookItem)
